import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import CapsulaModel from "@/models/capsulaModel";
import capsulaService from "@/services/capsulaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class CapsulaListComponent extends ListComponentBase<CapsulaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("numero", "Número", GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(capsulaService, "capsula", "descricao", true);
    }
}
